module.exports = __webpack_public_path__ + "media/photo/dev_discuse-0f6de622.png";